const enums = {
  JET: { text: 'jet', value: 1 },
  PRINTIFY: { text: 'printify', value: 2 },
  DIY: { text: 'diy', value: 3 },
  FITTINGS: { text: 'fittings', value: 4 },
  SDS: { text: 'sds', value: 5 }
}
export default enums
